import * as React from "react";
import styled from "styled-components";
import useD365Form from "../../../hooks/d365-form/use-d365-form";
import { useStaticQuery, graphql } from "gatsby";

const Root = styled.div({
  marginTop: 10,
});

function WhatComesNextForm() {
  const { site } = useStaticQuery(query);
  const isOEE = site.siteMetadata.vorneDomain === "https://www.oee.com";
  const formId = isOEE
    ? "b2cbfc80-c822-ee11-9cbd-002248292e69"
    : "754ff099-c822-ee11-9cbd-002248292e69";
  const websiteId = isOEE
    ? "PnT9Zh45RLmtv6vAE84FnuUNhFe_0aGcAECRWc1l99Y"
    : "dpzmq4nDU89h4txWoGGwugz5IMbVhmxLl-B9MlmdtOqs";
  const hostName = "2a768ee8dd2f4342b33eafb283a2318a.svc.dynamics.com";

  useD365Form({ formId });

  return (
    <Root>
      <div data-form-block-id={formId} />
      <div
        id={
          isOEE
            ? "dpzmq4nDU89h4txWoGGwugz5IMbVhmxLl-B9MlmdtOqs"
            : "dbH9gL5CgTEXeI7lOfYJDtzA5vZhSnshbap7glwz_yM8"
        }
      />
      <div
        className="d365-mkt-config"
        style={{ display: "none" }}
        data-website-id={websiteId}
        data-hostname={hostName}
      />
    </Root>
  );
}

const query = graphql`
  query {
    site {
      siteMetadata {
        titleBase
        leadSource
        contactSource
        vorneDomain
      }
    }
  }
`;

export default WhatComesNextForm;
